/* Scan to add — BEAMUN.
   Reads a product handle from the QR code's query string, adds it to the cart
   through the Ajax API, then shows what is in the bag so far. Adding is
   cumulative, so scanning three codes leaves three products in one cart. */

(function () {
  var root = document.querySelector('[data-scan-root]');
  if (!root) return;

  function show(name) {
    root.querySelectorAll('[data-state]').forEach(function (el) {
      el.hidden = el.getAttribute('data-state') !== name;
    });
  }

  function fail(message) {
    var target = root.querySelector('[data-scan-error]');
    if (target) target.textContent = message;
    show('error');
  }

  function money(cents) {
    var currency = root.getAttribute('data-currency') || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  var params = new URLSearchParams(window.location.search);
  var handle = (params.get('p') || params.get('product') || window.location.hash.replace('#', '')).trim();
  var variantParam = params.get('v') || params.get('variant');
  var quantity = parseInt(params.get('q') || params.get('quantity') || '1', 10);
  if (!(quantity > 0)) quantity = 1;

  if (!handle && !variantParam) {
    fail('That code did not carry a product with it. Try scanning it again, or browse the shop.');
    return;
  }

  /* Strip the query so a refresh or a back button does not add the same
     product a second time. */
  function clearQuery() {
    try {
      window.history.replaceState({}, '', window.location.pathname);
    } catch (e) {}
  }

  function addToCart(variantId, product) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || body.message || 'That product could not be added.');
          return body;
        });
      })
      .then(function () {
        clearQuery();
        if (root.getAttribute('data-go-straight-to-cart') === 'true') {
          window.location.href = root.getAttribute('data-cart-url') || '/cart';
          return null;
        }
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        render(product, cart);
      });
  }

  function render(product, cart) {
    var image = root.querySelector('[data-scan-image]');
    var title = root.querySelector('[data-scan-title]');
    var price = root.querySelector('[data-scan-price]');
    var summary = root.querySelector('[data-scan-summary]');

    if (product) {
      if (image && product.featured_image) {
        image.src = product.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2');
        image.alt = product.title;
      } else if (image) {
        image.remove();
      }
      if (title) title.textContent = product.title;
      if (price) price.textContent = money(product.price);
    }

    if (summary) {
      var count = cart.item_count;
      summary.textContent =
        (count === 1 ? '1 item in your bag' : count + ' items in your bag') + ' · ' + money(cart.total_price);
    }

    show('added');
  }

  if (variantParam) {
    addToCart(parseInt(variantParam, 10), null).catch(function (err) {
      fail(err.message || 'Something went wrong adding that product.');
    });
    return;
  }

  fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
    .then(function (res) {
      if (!res.ok) throw new Error('We could not find that product. It may have sold out or changed name.');
      return res.json();
    })
    .then(function (product) {
      var variant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) { variant = product.variants[i]; break; }
      }
      if (!variant) throw new Error(product.title + ' is out of stock at the moment.');
      return addToCart(variant.id, product);
    })
    .catch(function (err) {
      fail(err.message || 'Something went wrong adding that product.');
    });
})();
